export const SUPPORTED_APP_LANGUAGES = [
  "en-US",
  "es-ES",
  "fr-FR",
  "pt-PT",
  "ru-RU",
];

export const LANGUAGE_LABELS: Record<string, string> = {
  "en-US": "English",
  "es-ES": "Español",
  "fr-FR": "Français",
  "pt-PT": "Português",
  "ru-RU": "Русский",
};

export const shortLanguageCode = (language: string) =>
  String(language || "").split("-", 1)[0] || language;

export const buildLanguageLabel = (
  language: string,
  languageNames: Record<string, string> = {}
) =>
  `${
    languageNames[language] || LANGUAGE_LABELS[language] || language
  } (${shortLanguageCode(language)})`;

export const buildLanguageOptions = (
  languages: string[],
  languageNames: Record<string, string>
) =>
  languages.map((lang) => ({
    label: buildLanguageLabel(lang, languageNames),
    value: lang,
  }));
